import React, { useState, useEffect } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Dynamic_PR_table from "../../../../components/Dynamic_PR_table";
import { API_URL } from "../../../../constants";
import {
  GetServiceCaller,
  PostServiceCaller,
} from "../../../../services/serviceCaller";
import { useDispatch } from "react-redux";
import { updateNavbarHeading } from "../../../../constants/layout/store/filterSlice";

const Designation = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(updateNavbarHeading("Designation"));
  }, []);
  const [searchTerm, setSearchTerm] = useState("");
  const [holiday, setHoliday] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [errors, setErrors] = useState({});
  const [apiStatus, SetApiStatus] = useState(undefined);
  const [filteredSuggestions, setFilteredSuggestions] = useState([]);
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [formData, setFormData] = useState({
    Name: "",
    Code: "",
    Description: "",
    IsGroup: 0,
  });

  const columns = {
    Code: { text: "Code", align: "start", visible: true },
    Name: { text: "Name", align: "start", visible: true },
    IsGroup: { text: "Active", align: "center", visible: true },
  };
  const defaultColumns = {
    Code: true,
    Name: true,
    IsGroup: true,
  };

  const handleEdit = async (id) => {
    setShowModal(true);
    setIsEditMode(true);
    try {
      const response = await GetServiceCaller(
        `${API_URL}designationmaster/${id.ID}`
      );

      if (response.status === 200) {
        const depData = response?.data?.data;

        if (depData) {
          const { Name, Code, Description, IsGroup } = depData;
          // Update form data with fetched values, including IsGroup
          setFormData({
            id: id.ID,
            Name: Name || "",
            Code: Code || "",
            Description: Description || "",
            IsGroup: IsGroup === 1 ? 1 : 0, // Ensure IsGroup is either 1 or 0
          });
        }
      } else {
        console.error(
          "Failed to fetch Designation details. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error fetching Designation details:", error);
    }
  };

  const fetchDesignation = async () => {
    try {
      const response = await GetServiceCaller(`${API_URL}designationmaster`);
      SetApiStatus(response?.status);
      const data = response?.data?.data;
      // const updatedData = data.map((item) => ({
      //   ...item,
      //   IsGroup: item.IsGroup === 0 ? "No" : "Yes",
      // }));
      setHoliday(data);
          const allNames = data.map((item) => item.Name);
        setSuggestions(allNames);
    } catch (error) {
      console.error("Error fetching skills:", error);
    }
  };
  useEffect(() => {
    fetchDesignation();
  }, []);

  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;

    // Update form data
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? (checked ? 1 : 0) : value,
    });
  if (name === "Name") {
      // Filter suggestions that match input
      const matchedSuggestions = suggestions.filter((suggestion) =>
        suggestion.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredSuggestions(matchedSuggestions);
      setShowSuggestions(value.length > 0 && matchedSuggestions.length > 0);
    }
    // Clear the error for this field if it exists
    if (errors[name]) {
      setErrors((prevErrors) => {
        const newErrors = { ...prevErrors };
        delete newErrors[name];
        return newErrors;
      });
    }
  };

  const resetFormState = () => {
    setFormData({
      Name: "",
      Code: "",
      Description: "",
    });
    setIsEditMode(false);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.Code) newErrors.Code = "Code is required";
    if (!formData.Name) newErrors.Name = "Name is required";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

const handleSubmit = async (event) => {
  event.preventDefault();
  if (validateForm()) {
    const method = isEditMode ? "put" : "post";
    const apiUrl = isEditMode
      ? `${API_URL}designationmaster/${formData.id}`
      : `${API_URL}designationmaster`;

    try {
      const response = await PostServiceCaller(apiUrl, formData, method);

      // Check for successful response (multiple success indicators)
      if (
        response &&
        (response.status === "success" ||
          response.status === 200 ||
          response.statusCode === 200)
      ) {
        const successMessage =
          method === "post"
            ? "Form submitted successfully!"
            : "Form updated successfully!";
        toast.success(successMessage);
        resetFormState();
        fetchDesignation();
        setIsEditMode(false);
        setShowModal(false);
      } else {
        // Show API's error message if available
        const errorMessage = response?.message || response?.data?.message;
        console.error("API error:", errorMessage);
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      // Handle network errors and API error responses
      const errorMessage =
        error.response?.data?.message ||
        error.message ||
        "Error submitting form.";
      toast.error(errorMessage);
    }
  }
};
  useEffect(() => {
    const handleClickOutside = (event) => {
      const suggestionsElement = document.querySelector(
        ".suggestions-container"
      );
      const inputElement = document.getElementById("Name");
      if (
        showSuggestions &&
        suggestionsElement &&
        !suggestionsElement.contains(event.target) &&
        inputElement !== event.target
      ) {
        setShowSuggestions(false);
      }
    };

    if (showModal) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showModal, showSuggestions]);
  const handleEditModalClose = () => {
    setShowModal(false);
    resetFormState();
    setErrors({});
  };

  const handleAddForm = () => {
    resetFormState();
    setShowModal(true);
  };

  return (
    <>
      <div className="container-fluid" id="skill_section">
        <div className="container-fluid" id="skill-table-area">
          <div className="row mt-2">
            <Dynamic_PR_table
              data={holiday}
              columns={columns}
              defaultColumns={defaultColumns}
              itemsPerPage={8}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
              showIcon1={true}
              isSorting={true}
              isAddNewBtnRequired={true}
              isActionRequired={true}
              handleAddNew={handleAddForm}
              handleIcon1={handleEdit}
              isApiStatus={apiStatus}
              isRequiredStatus={true}
              icons={{
                Icon1: <i className="bi bi-pencil-square icons"></i>,
              }}
            />
          </div>
        </div>
        {/* Bootstrap Modal */}
        {showModal && (
          <div
            className="modal"
            tabIndex="-1"
            role="dialog"
            style={{
              display: "block",
              backgroundColor: "rgba(0, 0, 0, 0.5)",
            }}
          >
            <div
              className="modal-dialog modal-dialog-centered modal-md"
              role="document"
            >
              <div className="modal-content">
                <div
                  className="modal-header"
                  style={{
                    display: "flex",

                    justifyContent: "space-between",

                    alignItems: "center",

                    borderBottom: "1px solid #f0f0f0",

                    backgroundColor: "#f8f9fa",

                    borderRadius: "8px 8px 0 0",
                  }}
                >
                  <p
                    style={{
                      fontSize: "16px",

                      fontWeight: "600",

                      color: "#27568B",

                      margin: "0",
                    }}
                  >
                    {isEditMode ? "Edit Designation" : "Add Designation"}
                  </p>
                  <span className="me-2">
                    <i
                      className="bi bi-x-lg"
                      onClick={handleEditModalClose}
                    ></i>
                  </span>
                </div>
                <div className="modal-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-4">
                        <div class="mb-3">
                          <label for="Code" class="form-label">
                            Code<span className="required">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${
                              errors.Code ? "is-invalid" : ""
                            }`}
                            id="Code"
                            aria-describedby="Code"
                            name="Code"
                            placeholder="Code"
                            value={formData.Code}
                            onChange={handleInputChange}
                          />
                          {errors.Code && (
                            <div className="invalid-feedback">
                              {errors.Code}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-8">
                        <div class="mb-3">
                          <label for="Code" class="form-label">
                            Name<span className="required">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${
                              errors.Name ? "is-invalid" : ""
                            }`}
                            id="Name"
                            aria-describedby="Name"
                            name="Name"
                            placeholder="Name"
                            value={formData.Name}
                            onChange={handleInputChange}
                            autocomplete="off"
                          />
                          {showSuggestions &&
                            filteredSuggestions.length > 0 && (
                              <div
                                className="suggestions-container"
                                style={{
                                  position: "absolute",
                                  width: "60%",
                                  maxHeight: "200px",
                                  overflowY: "auto",
                                  backgroundColor: "#fff",
                                  border: "1px solid #ddd",
                                  borderRadius: "4px",
                                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                                  zIndex: 1000,
                                  marginTop: "2px",
                                }}
                              >
                                <div
                                  style={{
                                    padding: "8px 12px",
                                    fontSize: "0.8rem",
                                    color: "#666",
                                    borderBottom: "1px solid #eee",
                                    backgroundColor: "#f8f9fa",
                                  }}
                                >
                                  Existing matching Designation:
                                </div>
                                <ul
                                  style={{
                                    listStyle: "none",
                                    padding: 0,
                                    margin: 0,
                                  }}
                                >
                                  {filteredSuggestions.map(
                                    (suggestion, index) => (
                                      <li
                                        key={index}
                                        style={{
                                          padding: "8px 12px",
                                          fontSize: "0.9rem",
                                          borderBottom: "1px solid #eee",
                                          color: "#333",
                                          cursor: "default", // Disable pointer cursor
                                        }}
                                      >
                                        {suggestion}
                                      </li>
                                    )
                                  )}
                                </ul>
                              </div>
                            )}
                          {errors.Name && (
                            <div className="invalid-feedback">
                              {errors.Name}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-12">
                        <div class="mb-3">
                          <label for="Code" class="form-label">
                            Description
                          </label>
                          <textarea
                            type="text"
                            class="form-control"
                            id="Description"
                            aria-describedby="Description"
                            name="Description"
                            placeholder="Description"
                            value={formData.Description}
                            onChange={handleInputChange}
                          ></textarea>
                        </div>
                      </div>
                      <div className="col-12">
                        <div className="row">
                          <div className="col-sm-3">
                            <label
                              htmlFor="flexSwitchCheckChecked"
                              className="form-label me-2"
                            >
                              Active
                            </label>
                            <input
                              className="form-check-input"
                              type="checkbox"
                              name="IsGroup"
                              id="flexSwitchCheckChecked"
                              checked={formData.IsGroup === 1}
                              onChange={handleInputChange}
                            />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="text-end mt-2">
                      <button
                        type="button"
                        className="cancel-btn me-2"
                        onClick={handleEditModalClose}
                      >
                        Cancel
                      </button>
                      <button type="submit" className="custom-btn">
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default Designation;
